// src/services/authService.js
import api from "./api";

// login API call
export const loginService = async (credentials) => {
  const response = await api.post("/api/login", credentials);
  return response.data;
};

export const getServicesByRoleId = async (roleId) => {
  try {
    const response = await api.get(`/api/role-service-mapping/role/${roleId}/services-status`);
    console.log('API Response:', response);
    return response.data;
  } catch (err) {
    console.error('Full error object:', err);
    console.error('Error config:', err.config);
    console.error('Error response:', err.response);
  }
};



export const assignServicesToRole = async (roleId, assignedServiceIds) => {
  try {
    const response = await api.post(
      `/api/role-service-mapping/${roleId}/assign-services`,
      assignedServiceIds, // body
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (err) {
    console.error("Error in assignServicesToRole:", err);
    throw err;
  }
};




export const logoutService = async (employeeId) => {
  try {
    if (!employeeId) {
      throw new Error("No employeeId or token found");
    }

    // Make the API request to log out the user
    await api.post(`/api/logout`, { employeeId });

    // Clear local storage after successful logout
    localStorage.removeItem('employeeId');
    localStorage.removeItem('token');

    return { success: true };
  } catch (error) {
    console.error("Logout failed:", error);
    throw new Error("There was an error logging out. Please try again later.");
  }
};
export const getProfile = async (employeeId) => {
  const response = await api.get(`/api/personal-info/profile/${employeeId}`);
  return response.data;

}